import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuctionInfoComponent } from '../components/auction-info/auction-info.component';
import { VehicleCardListComponent } from '../components/vehicle-card-list/vehicle-card-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon'; // Import MatIconModule
@NgModule({
  declarations: [AuctionInfoComponent,VehicleCardListComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatIconModule    
  ],
  exports:[AuctionInfoComponent,VehicleCardListComponent]
})
export class SharedModule { }
